import React from 'react';

const CustomCursor = () => {
  const cursorSm = React.useRef(null);
  // If you want a large cursor, uncomment the next line and add it to the JSX
  // const cursorLg = React.useRef(null);
  const positionRef = React.useRef({
    mouseX: 0,
    mouseY: 0,
    destinationX: 0,
    destinationY: 0,
    distanceX: 0,
    distanceY: 0,
    key: -1,
  });

  React.useEffect(() => {
    const handleMouseMove = event => {
      const { clientX, clientY } = event;
      if (cursorSm.current) {
        positionRef.current.mouseX = clientX - cursorSm.current.clientWidth / 2;
        positionRef.current.mouseY = clientY - cursorSm.current.clientHeight / 2;
      }
    };
    document.addEventListener('mousemove', handleMouseMove);
    return () => document.removeEventListener('mousemove', handleMouseMove);
  }, []);

  React.useEffect(() => {
    let animationFrameId;
    const followMouse = () => {
      const {
        mouseX,
        mouseY,
        destinationX,
        destinationY,
        distanceX,
        distanceY,
      } = positionRef.current;
      if (typeof destinationX !== 'number' || typeof destinationY !== 'number') {
        positionRef.current.destinationX = mouseX;
        positionRef.current.destinationY = mouseY;
      } else {
        positionRef.current.distanceX = (mouseX - destinationX) * 0.1;
        positionRef.current.distanceY = (mouseY - destinationY) * 0.1;
        if (
          Math.abs(positionRef.current.distanceX) +
            Math.abs(positionRef.current.distanceY) <
          0.1
        ) {
          positionRef.current.destinationX = mouseX;
          positionRef.current.destinationY = mouseY;
        } else {
          positionRef.current.destinationX += distanceX;
          positionRef.current.destinationY += distanceY;
        }
      }
      if (cursorSm.current) {
        cursorSm.current.style.transform = `translate3d(${positionRef.current.destinationX}px, ${positionRef.current.destinationY}px, 0)`;
      }
      animationFrameId = requestAnimationFrame(followMouse);
    };
    followMouse();
    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <div
      ref={cursorSm}
      id="custom-cursor"
      style={{
        position: 'fixed',
        width: 20,
        height: 20,
        borderRadius: '50%',
        background: 'rgba(248, 182, 39, 0.5)',
        pointerEvents: 'none',
        zIndex: 9999,
        left: 0,
        top: 0,
        transform: 'translate3d(0,0,0)',
        transition: 'background 0.2s, transform 0.1s',
      }}
    />
  );
};

export default CustomCursor;